import { Route, Routes } from 'react-router-dom';
import { ExpertHubLayout } from 'components/templates';
import NewsfeedList from './components/newsfeed-list';
import './style.scss';

const NewsFeed = () => (
  <ExpertHubLayout>
    <Routes>
      <Route path="/" element={<NewsfeedList />} />
    </Routes>
  </ExpertHubLayout>
);

export default NewsFeed;
